import en from './en';

const fr: typeof en = {
  federalTaxRegistrationNumber: 'Numéro d’inscription aux taxes fédérales (GST/HST)',
  provincialTaxRegistrationNumber: 'Numéro d’inscription aux taxes provinciales (PST/RST/QST/TVQ)',
  isFederalTaxExempt: 'Exonéré de la taxe fédérale',
  isProvincialTaxExempt: 'Exonéré de la taxe provinciale',
  isApprovedByUnderwriter: 'Approuvé par le souscripteur',
  federalTaxRegistrationRequiredForExemption:
    'Un numéro d’inscription aux taxes fédérales est requis pour permettre l’exonération',
  provincialTaxRegistrationRequiredForExemption:
    'Un numéro d’inscription aux taxes provinciales est requis pour permettre l’exonération',
  consents: 'Consents',
  consentNumber: 'Numéro de consentement',
  token: 'Jeton',
  accepted: 'Accepté',
  acceptanceStatus: "Statut d'acceptation",
  postingAccount: 'Compte de publication',
  postingAccounts: 'Comptes de publication',
  accountReceivable: 'Compte a recevoir',
  accountReceivables: 'Comptes a recevoir',
  accountReceivableImportExcel: 'Importer les comptes a recevoir',
  postingAccountName: 'Nom du compte de publication',
  selectAll: 'Tout sélectionner',
  selectNone: 'Ne rien sélectionner',
  sendPaymentRequest: 'Envoyer une demande de paiement',
  setIsTransferIndicatorInvisible: 'Définir l’indicateur de transfert invisible',
  sendPaymentRequestTo: 'Envoyer une demande de paiement à',
  payeeEmailIsRequired: "L'adresse e-mail du bénéficiaire est obligatoire",
  paymentRequiresClaimToBeInCorrectStatus: 'Le paiement nécessite que la réclamation soit dans un état correct',
  paymentIsAvailableOnlyFor: 'Le paiement est disponible uniquement pour US Bank (CAD)',
  paymentRequestEmailIsAvailableOnlyFor:
    "L'e-mail de demande de paiement est disponible uniquement pour les paiements par EFT/chèque",
  missingPayeePaymentMethods: 'Au moins un bénéficiaire n’a pas de mode de paiement',
  consentSenderEmail: 'Email de l’expéditeur du consentement',
  insurerAdjustedAmtMustBeEqualOrLessThanAmount:
    'Le montant ajusté de l’assureur doit être égal ou inférieur à {amount}',
  insurerAdjudicationsMustBeFilledBeforeApproval:
    'Les valeurs d’adjudication de l’assureur doivent être remplies avant l’approbation du travail',
  insurerAdjudicationTotalsMustMatchAdjustedAmt:
    'Les totaux d’adjudication de l’assureur doivent correspondre aux montants ajustés avant l’approbation du travail',
  insurerAdjudicationTotalMustMatchAdjustedAmt:
    'Le total d’adjudication de l’assureur doit correspondre au montant ajusté : {amount}',
  sendPaymentRequestEmail: 'Envoyer un e-mail de demande de paiement',
  enterAccountingEmail: "Entrez l'e-mail de comptabilité",
  accountingEmails: 'Courriels comptables',
  pleaseSaveJobToDoPayment: 'Veuillez enregistrer le travail pour effectuer le paiement',
  youAlreadyHavePendingPayment: 'Vous avez déjà un paiement en attente',
  maximumMarkup: 'Marge maximale',
  alreadyPaid: 'Déjà payé',
  paymentAt: 'Paiement à',
  totalBeforeTax: 'Total avant taxes',
  dealerName: 'Nom du concessionnaire',
  dealerId: 'ID du concessionnaire',
  paymentUser: 'Utilisateur de paiement',
  isPaymentSent: 'Le paiement est-il envoyé',
  isPaymentSentViaUsBank: 'Le paiement est-il envoyé via US Bank',
  isPaymentSentManually: 'Le paiement est-il envoyé manuellement',
  paymentSent: 'Paiement envoyé',
  expiredClaimCreationWarning: 'Êtes-vous sûr de vouloir créer une réclamation pour un contrat qui est expiré',
  paymentSentViaUsBank: 'Paiement envoyé via une banque américaine',
  paymentSentManually: 'Paiement envoyé manuellement',
  sent: 'Envoyé',
  sentManually: 'Envoyé manuellement',
  sendManually: 'Envoyer manuellement',
  manualPayment: 'Paiement manuel',
  payManually: 'Payer manuellement',
  incidentLocalDate: "Date de l'incident",
  dateMustBeInRangeFromTo: 'La date doit être comprise entre {{fromDate}} et {{toDate}}',
  dateMustBeInNDayRangeFromToday: 'La date doit être dans un intervalle de {{n}} jours à partir d’aujourd’hui',
  productDocumentsFromTemplate: 'Documents de produit à partir du modèle',
  productTemplateDocuments: 'Documents de modèles de produits',
  en: 'Anglais',
  fr: 'Français',
  month: 'Mois',
  resendToDocuSign: 'Renvoyer à DocuSign',
  resendForSigning: 'Renvoyer pour signature',
  DocuSign: 'DocuSign',
  signingOptions: 'Options de signature',
  downloadSignedDocuments: 'Téléchargez les documents signés.',
  reuploadSignedDocuments: 'Retélécharger les documents signés.',
  importMissingSigningCertificates: 'Importer les certificats manquants',
  importSignedDocumentationAggregates: 'Importer les documents signés',
  signingCertificates: 'certificats de signature',
  signedDocuments: 'documents signés',
  noSignedContractsWithMissingSigningCertificate: 'Aucun contrat signé sans certificat de signature!',
  noContractsSignedWithSignFlow: 'Aucun contrat signé avec SignFlow!',
  importedItemsSummary: '{{imported}}/{{total}} {{entity}} importés.',
  progressWindowStatus:
    '{{title}} : {{currentItem}}/{{totalItems}} | {{percentCompleted}}% | Estimé {{estimatedSeconds}}s',
  goToTop: 'Aller en haut',
  months: 'Mois',
  uploadedBy: 'Téléchargé par',
  payAll: 'Payer tout',
  isPaymentRequired: 'Le paiement est-il requis',
  paymentOptions: 'Options de paiement',
  paymentPrice: 'Prix de paiement',
  signAll: 'Signer tout',
  signManually: 'Signer manuellement',
  signedManually: 'Signé manuellement',
  allSigned: 'Tous signés',
  signedWithDocuSign: 'Signé avec DocuSign',
  signedWithSignFlow: 'Signé avec SignFlow',
  sentForSigning: 'Envoyé pour signature',
  distributorPrice: 'Prix distributeur',
  changeStatusAndSendEmail: 'Changer le statut et envoyer un e-mail',
  changeStatusAndDontSendEmail: 'Changer le statut sans envoyer d’e-mail',
  saveJobTable: 'Enregistrer le tableau des tâches',
  surchargesPrice: 'Prix des suppléments',
  stockNumber: 'Numéro de stock',
  at: 'à',
  revise: 'Réviser',
  cancel: 'Annuler',
  number: 'Nombre',
  generateDocuments: 'Générer des documents',
  sendDocumentForSigning: 'Envoyer le document pour signature',
  changeLayout: 'Modifier la mise en page',
  submit: 'Soumettre',
  item: 'Article',
  resetPassword: 'Réinitialiser le mot de passe',
  additionalDocumentation: 'Documentation complémentaire',
  supportingDocumentation: 'Pièces justificatives',
  coApplicantFirstName: 'Prénom du codemandeur',
  coApplicantLastName: 'Nom de famille du codemandeur',
  surchargeDocuments: 'Documents de supplément',
  adjustedPrice: 'Prix ajusté',
  adjustedAmt: 'Montant ajusté',
  requestedAmt: 'Montant Demandé',
  jobItemTemplates: "Modèles d'éléments de travail",
  jobItemTemplate: "Modèle d'élément de travail",
  jobItems: 'Éléments de travail',
  items: 'Éléments',
  updateDraft: 'Mettre à jour le brouillon',
  originalPrice: "Prix d'origine",
  basePrice: 'Prix de base',
  priceCAD: 'Prix',
  usBank: 'UsBank',
  apiKey: 'Clé API',
  callbackUrl: 'URL de rappel',
  secretKey: 'Clé secrète',
  usBankOptions: 'Options UsBank',
  usBankCreatePayment: 'UsBank Créer un paiement',
  usBankModifyPayment: 'UsBank Modifier le paiement',
  usBankCancelPayment: 'UsBank Annuler le paiement',
  usBankInfoPayment: 'Informations de paiement UsBank',
  createPayment: 'Créer un paiement',
  modifyPayment: 'Modifier le paiement',
  cancelPayment: 'Annuler le paiement',
  areYouSureYouWantToCancelThisPayment: 'Êtes-vous sûr de vouloir annuler ce paiement?',
  areYouSureYouWantToExcludeThisPaymentItem: 'Êtes-vous sûr de vouloir exclure cet élément de paiement?',
  thisPaymentMayHavePendingUsBankPayments:
    'Ce paiement peut déjà avoir des transactions en attente de traitement par US Bank!',
  infoPayment: 'Informations paiement',
  empty: 'Vide',
  mustBeLessThanAmount: 'Doit être inférieur à {amount}',
  minMaxMissmatchMessage: 'La valeur maximale doit être supérieure à la valeur minimale',
  mustBeEqualOrLessThanAmount: 'Doit être égal ou inférieur à {amount}',
  mustBEqualToValue: 'Must be equal to {value}',
  minAmount: 'Montant minimum',
  maxAmount: 'Montant maximum',
  additionType: "Type d'ajout",
  legacyClaimHistory: 'Historique des réclamations héritées',
  claimHistory: 'Historique des réclamations',
  alertsAndNotifications: 'Alertes et notifications',
  engineType: 'Type de moteur',
  fuelType: 'Type de carburant',
  engineInfo: 'Informations sur le moteur',
  province: 'Province',
  exclude: 'Exclure',
  excluded: 'Exclu',
  adjusted: 'Ajusté',
  adjustments: 'Ajustements',
  adjustment: 'Ajustement',
  createStatement: 'Créer un paiement',
  selectAtLeastOneContract: 'Sélectionnez au moins un contrat',
  contractsMustBelongToSameDealer: 'Les contrats doivent appartenir au même concessionnaire',
  missingPermission: 'Permission manquante',
  statementP1: 'Si vous émettez un chèque',
  statementP2: 'veuillez le faire au nom de',
  statementBalanceDue: 'Le solde dû est payable a réception',
  balanceDue: 'Solde dû',
  app: 'N° de contrat',
  stock: 'N° de stock',
  statementEffectiveOn: 'Effectif à partir du',
  statementSalesTax: 'Taxe sur les ventes',
  numberOfApps: '# de contrats',
  statementTier: 'Niveau',
  zeroTo30Days: '0 à 30 jours',
  thirtyOneTo60Days: '31 à 60 jours',
  sixtyOneTo90Days: '61 à 90 jours',
  ninetyOnePlusDays: 'Plus de 90 jours',
  salesTax: 'Taxe de vente',
  subtotal: 'Sous-total',
  statements: 'Paiements',
  statement: 'Paiement',
  statementStatusTrigger: 'Statut du paiement',
  statementSummary: 'Résumé du paiement',
  statementBalanceStatusTrigger: 'Statut du relevé',
  statementEmailTemplates: 'Modèles d’e-mail pour paiement',
  statementBalanceEmailTemplates: 'Modèles d’e-mail pour relevé',
  noStatementsSelectedForSendingAnEmail: 'Aucun paiement sélectionné pour l’envoi d’e-mail',
  noStatementBalancesSelectedForSendingAnEmail: 'Aucun relevé sélectionné pour l’envoi d’e-mail',
  statementBalances: 'Relevés',
  statementBalance: 'Relevé',
  statementBalancePdf: 'Relevé',
  statementBalanceCancelationRisks: 'Les éléments ci-dessus sont à risque d’annulation.',
  statementBalanceRemit:
    'Veuillez régler le solde dû dès réception. Merci. Les contrats ou demandes qui ne sont pas entièrement payés dans un délai de 60 jours pourront être réputés NULS. Pour toute question, veuillez envoyer un courriel à:',
  statementBalanceImportantNotice:
    'Les modalités, ou termes et conditions, établis par les assureurs sont régis par l’organisme de réglementation de chaque province. Le délai maximal de réception du paiement est de 60 jours nets. Les demandes et contrats seront automatiquement annulés conformément aux règlements provinciaux, sans aucune exception. Toute violation de cette politique pourrait entraîner la perte de votre capacité à vendre de futures demandes ou de futurs contrats.',
  statementChangeDate: 'Date de changement du statut du paiement',
  datePaymentReceived: 'Date de réception du paiement',
  cantChangeProduct: 'Vous ne pouvez pas changer de produit',
  mustBeMoreThanAmount: 'Doit être supérieur à {amount}',
  itemsAdded: 'éléments ajoutés',
  groups: 'Groupes',
  make: 'Marque',
  property: 'Propriété',
  prices: 'Prix',
  download: 'Télécharger',
  downloadAll: 'Télécharger tout',
  importPrices: 'Importer les prix',
  importPricesWithPreview: 'Importer les prix avec aperçu',
  importPricingPlanClassesForProduct: 'Importer les classes de plan tarifaire pour le produit',
  downloadAllClaimDocuments: 'Télécharger tous les documents de réclamation',
  downloadAllClaimJobsDocuments: 'Télécharger tous les documents des travaux de réclamation',
  downloadClaimDocuments: 'Télécharger les documents de réclamation',
  automationExpressions: "Expressions d'automatisation",
  automationRules: "Règles d'automatisation",
  operator: 'Opérateur',
  propertyValues: 'Valeurs des propriétés',
  serviceAdviser: 'Conseiller de service',
  serviceAdvisor: 'Conseiller de service',
  damageOccurredLocation: 'Lieu des dommages survenus',
  windshieldCostOfRepair: 'Coût de réparation du pare-brise',
  goToPrices: 'Accéder aux prix',
  vehicleMakes: 'Marques de véhicules',
  vehicleMakeImportExcel: 'Importer la marque du véhicule',
  vehicleInServiceDateValidationMsg:
    'L’âge du véhicule dépasse les limites autorisées! Veuillez vérifier la date de mise en service!',
  viewFiles: 'Voir les fichiers',
  pst: 'PST',
  pstPaid: 'PST payé',
  gstHst: 'GST/HST',
  gstHstPaid: 'GST/HST payé',
  salePrice: 'Prix de vente',
  dealerProfit: 'Profit du concessionnaire',
  retailSalePrice: 'Prix de vente au détail',
  isInactive: 'Est inactif',
  isStatementAutoEmailEnabled: "L'envoi automatique des paiement par e-mail est-il activé ?",
  isStatementBalanceAutoEmailEnabled: "L'envoi automatique des relevés par e-mail est-il activé ?",
  isClaimTypeJobItemsAutomationEnabled: "L'automatisation des éléments de travail ClaimType est-elle activée ?",
  isClaimTypeAutomationEnabled: "L'automatisation ClaimType est-elle activée ?",
  claimTypeJobItemsAutoCond: 'Éléments de travail ClaimType auto. cond.',
  claimTypeAutomation: 'Automatisation des types de réclamations',
  someSelectedClaimsCannotChangeOwner: 'Certains réclamations sélectionnées ne peuvent pas changer de propriétaire',
  regenerateContractDocuments: 'Régénérer les documents contractuels',
  contractConsentProductAggregates: 'Agrégats de produits de consentement contractuel',
  contractConsentProductAgg: 'Consentement au contrat prod. agg.',
  consentProductAgg: 'Consentement prod. agg.',
  consentVideoLink: 'Lien de la vidéo de consentement',
  cancellationFullRefundPeriodInDays: "Délai d'annulation avec remboursement complet (en jours)",
  dealerNameSimilarityScore: 'Score de similarité du nom du concessionnaire',
  amountDifference: 'Différence de montant',
  default: 'Défaut',
  contractConsentAggregateDescription: 'Description agrégée du consentement au contrat',
  deductible: 'Franchise',
  allValuesMustBeUnique: 'Toutes les valeurs doivent être uniques',
  upload: 'Télécharger',
  loading: 'Chargement',
  goToProductEdit: 'Aller à la modification du produit',
  goToEnhancementEdit: 'Aller à la modification de l’amélioration',
  primaryContactEmailAddress: 'Adresse e-mail de contact principale',
  streetAddress: 'Adresse de la rue',
  city: 'Ville',
  primaryEmailAddress: 'Adresse e-mail principale',
  primaryPhoneNumber: 'Numéro de téléphone principal',
  representative: 'Représentant',
  dealersAccounting: 'Comptabilité des concessionnaires',
  tax: 'Taxe',
  isDisabled: 'Désactivé',
  uploadingPleaseWait: '"Téléchargement en cours',
  driveLine: 'Ligne d’entraînement',
  pricesMustMatchCriteria: 'Les prix doivent correspondre aux critères',
  mustBeEqualOrMoreThanAmount: 'Doit être égal ou supérieur à {amount}',
  review: 'Revue',
  prev: 'Précédent',
  noPayee: 'Aucun bénéficiaire',
  return: 'Retour',
  refundProcess: 'Processus de remboursement',
  cancellationInfo: 'Détails d’annulation',
  cancellationHistory: 'Historique des annulations',
  lastCancellationDate: 'Date de la dernière annulation',
  lastCancellationReason: 'Motif de la dernière annulation',
  lastCancellationReasonDescription: 'Description du motif de la dernière annulation',
  lastOdometerReading: 'Dernière lecture du compteur kilométrique',
  lastRefundDate: 'Date du dernier remboursement',
  cancelRefund: 'Annuler le remboursement',
  cancellationNote: 'Note d’annulation',
  cancelledBy: 'Annulé par',
  cancelledAt: 'Annulé le',
  cancellationDate: "Date d'annulation",
  cancellationReason: "Motif d'annulation",
  cancellationReasonDescription: "Description du motif d'annulation",
  refund: 'Remboursement',
  refundDate: 'Date de remboursement',
  viewMore: 'Voir plus',
  viewLess: 'Voir moins',
  isRequired: 'Est requis',
  group: 'Groupe',
  filters: 'Filtres',
  sort: 'Trier',
  print: 'Imprimer',
  pay: 'Payer',
  requiresSyncing: 'Synchronisation requise',
  syncing: 'Synchronisation en cours',
  readyForUpdate: 'Prêt pour la mise à jour',
  pricingDistributions: 'Distributions de prix',
  trimLevel: 'Niveau de finition',
  unknownDocument: 'Document inconnu',
  bodyColor: 'Couleur de la carrosserie',
  DATE: 'Date',
  DATE_TIME: 'Date et heure',
  TEXT: 'Texte',
  LONG_TEXT: 'Texte long',
  BOOLEAN: 'Réponse oui/non',
  NUMBER: 'Nombre entier',
  DECIMAL: 'Nombre décimal',
  next: 'Suivant',
  notUnique: 'Pas unique',
  lenders: 'Prêteurs',
  lenderImportExcel: 'Importer un prêteur',
  limit: 'Limite',
  limits: 'Limites',
  program: 'Programme',
  programName: 'Nom du programme',
  programs: 'Programmes',
  distributionDoesntMatchOriginalPrice: "La distribution ne correspond pas au prix d'origine",
  contractWasSuccessFullyCreated: 'Le contrat a été créé avec succès',
  submitANewClaim: 'Soumettre une réclamation',
  searchContractEnteringVinAndContractNumberOrClientLastName:
    'Recherchez un contrat en inscrivant un NIV ainsi que le numéro de contrat ou le nom de famille du client',
  details: 'Détails',
  viewAllContracts: 'Voir tous les contrats',
  vehicleInfo: 'Informations sur le véhicule',
  cash: 'Comptant',
  finance: 'Finance',
  lease: 'Location',
  lineofcredit: 'Ligne de crédit',
  finish: 'Terminer',
  contractInfo: 'Informations sur le contrat',
  odometerReading: 'Lecture du compteur kilométrique',
  purchasePrice: "Prix d'achat",
  purchaseState: "État d'achat",
  purchaseType: "Type d'achat",
  financedAmount: 'Montant financé',
  residualAmount: 'Montant résiduel',
  paymentAmount: 'Montant du paiement',
  numberOfPayments: 'Nombre de paiements',
  interestRate: "Taux d'intérêt",
  term: 'Terme',
  apply: 'Appliquer',
  used: 'Utilisé',
  backToClaim: 'Retour à la réclamation',
  noItemsAdded: 'Aucun élément ajouté',
  createdAt: 'Créé à',
  createdAs: 'Créé comme',
  decidedDate: 'Date de décision',
  paymentDate: 'Date de paiement',
  owner: 'Propriétaire',
  notAssigned: 'Non attribué',
  createClaimForContract: 'Créer une réclamation pour un contrat',
  createClaimForExpiredContract: 'Créer une réclamation pour un contrat expiré',
  vertaforeStatus: 'Statut Vertafore',
  signingStatus: 'Statut de signature',
  showTables: 'Afficher les tableaux',
  indemnityCalculation: "Calcul de l'indemnité",
  hideTables: 'Masquer les tableaux',
  reset: 'Réinitialiser',
  comments: 'Commentaires',
  on: 'Activé',
  youNeedToSelectOneDocument: 'Vous devez choisir un document',
  off: 'Désactivé',
  search: 'Rechercher',
  waiting: 'En attente',
  uploaded: 'Téléchargé',
  missing: 'Manquant',
  missingContractDocument: 'Document de contrat manquant',
  generalInformation: 'Informations générales',
  separate: 'Séparé',
  totalItems: "Nombre total d'articles",
  itemsShown: 'Articles affichés',
  show: 'Afficher',
  hide: 'Cacher',
  showMore: 'Afficher plus',
  moveDown: 'Descendre',
  moveUp: 'Monter',
  close: 'Fermer',
  itemsSelected: 'Articles sélectionnés',
  confirmByCheckbox: 'Veuillez cocher la case pour confirmer vos actions',
  confirmByFourDigits: 'Veuillez répéter le numéro ci-dessous pour confirmer vos actions',
  userConfirmationRequired: "Confirmation de l'utilisateur requise",
  userMenu: 'Menu utilisateur',
  applicationMenu: "Menu de l'application",
  dealerMenu: 'Menu du concessionnaire',
  closeMenu: 'Fermer le menu',
  openMenu: 'Ouvrir le menu',
  updateDealer: 'Mettre à jour le concessionnaire',
  updateDistributorPrice: 'Mettre à jour le prix du distributeur',
  clearDistributorPrice: 'Effacer le prix du distributeur',
  openDistributorDistributionTable: 'Ouvrir le tableau de distribution du distributeur',
  openDealerPricingLimitationTable: 'Ouvrir le tableau des limitations de prix du concessionnaire',
  writeHere: 'Écrivez ici',
  confirm: 'Confirmer',
  username: "Nom d'utilisateur",
  password: 'Mot de passe',
  login: 'Connexion',
  mustNotBeEmpty: 'Ne doit pas être vide',
  totalAmountMustMatchOriginal: 'Le montant total doit correspondre à l’original',
  passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
  sessionHasTimedOut: 'La session a expiré',
  refreshingYourSession: 'Tentative d’actualisation de la clé de session…',
  invalidForm: 'Formulaire invalide',
  newPassword: 'Nouveau mot de passe',
  confirmPassword: 'Confirmer le mot de passe',
  oldPassword: 'Ancien mot de passe',
  changePassword: 'Changer le mot de passe',
  passwordWasSuccessfullyChanged: 'Le mot de passe a été modifié avec succès',
  weWereUnableToChangeYourPassword: "Nous n'avons pas pu changer votre mot de passe",
  invalidUsernameOrPassword: "Nom d'utilisateur ou mot de passe invalide",
  noInfo: 'Aucune information',
  noFiles: 'Aucun fichier',
  ok: 'OK',
  badRequest: 'Mauvaise demande',
  unauthorized: 'Non autorisé',
  notFound: 'Non trouvé',
  pageNotFound: 'Page non trouvée',
  internalServerError: 'Erreur interne du serveur',
  unknownError: 'Erreur inconnue',
  user: 'Utilisateur',
  users: 'Utilisateurs',
  firstName: 'Prénom',
  lastName: 'Nom de famille',
  lastActive: 'Dernière activité',
  internalSupportDeskUid: 'ID du support interne',
  email: 'Couriel',
  language: 'Langue',
  editMySettings: 'Modifier mes paramètres',
  ascendingByDate: 'Ascendant par date',
  descendingByDate: 'Descendant par date',
  ascendingByUserName: "Croissant par nom d'utilisateur",
  descendingByUserName: "Décroissant par nom d'utilisateur",
  ascendingByTerm: 'Croissant par terme',
  descendingByTerm: 'Décroissant par terme',
  ascendingByCode: 'Croissant par code',
  descendingByCode: 'Décroissant par code',
  application: 'Application',
  applications: 'Applications',
  startDate: 'Date de début',
  endDate: 'Date de fin',
  name: 'Nom',
  orderNumber: 'Numéro de commande',
  url: 'URL',
  permission: 'Permission',
  newerFirst: 'Le plus récent en premier',
  olderFirst: 'Les plus anciens en premier',
  permissions: 'Permissions',
  changeMadeBy: 'Changement effectué par',
  newStatus: 'Nouveau statut',
  oldStatus: 'Ancien statut',
  changedBy: 'Modifié par',
  changedOn: 'Modifié le',
  category: 'Catégorie',
  categories: 'Catégories',
  description: 'Description',
  secondaryDescription: 'Description secondaire',
  source: 'Source',
  assign: 'Attribuer',
  assign_from_source: 'Attribuer depuis la source',
  add_or_update: 'Ajouter ou mettre à jour',
  role: 'Rôle',
  roles: 'Rôles',
  info: 'Informations',
  additionalPermissions: 'Permissions supplémentaires',
  unlimited: 'Illimité',
  delete: 'Supprimer',
  addNew: 'Ajouter un nouveau',
  if: 'Si',
  is: 'est',
  to: 'à',
  between: 'entre',
  and: 'et',
  or: 'ou',
  not: 'non',
  start: 'Début',
  bracket: 'Parenthèse',
  expression: 'Expression',
  effect: 'Effet',
  expressionItem: "Élément d'expression",
  insertAfter: 'Insérer après',
  insertAtStart: 'Insérer au début',
  addExpressionItem: 'Insérer',
  addExpressionHere: 'Ajouter une nouvelle expression ici',
  addAndOperatorDescription: 'Les deux côtés doivent correspondre',
  addOrOperatorDescription: 'Un des deux côtés peut correspondre',
  addNotOperatorDescription: 'Inverse la prochaine expression ou le prochain groupe',
  arithmeticOperator: 'Opérateur arithmétique',
  relationalOperator: 'Opérateur relationnel',
  addOpenBracketDescription: 'Commencer une expression groupée',
  addCloseBracketDescription: 'Terminer une expression groupée',
  adjacentExpressionsImplicitAnd: '* Les expressions adjacentes sans opérateur sont interprétées comme Et.',
  addRule: 'Ajouter une règle',
  addExpression: 'Ajouter une expression',
  addEffect: 'Ajouter un effet',
  addAlert: 'Ajouter une alerte',
  editAlert: 'Modifier l’alerte',
  claimAlert: 'Alerte de réclamation',
  title: 'Titre',
  message: 'Message',
  deleteExpression: "Supprimer l'expression",
  deleteEffect: "Supprimer l'effet",
  deleteRule: 'Supprimer la règle',
  pricingAutomationRule: 'Règle d’automatisation des prix',
  pricingAutomationRules: 'Règles d’automatisation des prix',
  productPricingAutomationRule: 'Règle d’automatisation des prix du produit',
  productPricingAutomationRules: 'Règles d’automatisation des prix du produit',
  mandatory: 'Obligatoire',
  isMandatory: 'Est obligatoire',
  applySurchargeRuleDescription:
    'Si toutes les expressions sont remplies, cette règle ajoutera automatiquement un supplément au contrat',
  import: 'Importer',
  mySettings: 'Mes paramètres',
  logout: 'Déconnexion',
  accessedAt: 'Accédé le',
  accessLogs: "Journaux d'accès",
  changeLogs: 'Journaux des modifications',
  welcome: 'Bienvenue',
  personalInfo: 'Informations personnelles',
  accountInfo: 'Informations sur le compte',
  currentLanguage: 'Langue actuelle',
  attachments: 'Pièces jointes',
  attachment: 'Pièce jointe',
  claim: 'Réclamation',
  claimEmailTemplates: 'Modèles d’e-mail de réclamation',
  claimJobEmailTemplates: 'Modèles d’e-mail de travaux de réclamation',
  claimNumber: 'Numéro de réclamation',
  claimAuthorizationNumber: "Numéro d'autorisation de réclamation",
  claimJobAuthorizationNumber: "Numéro d'autorisation de la demande de travail",
  claimTotalAmount: 'Montant total de la réclamation',
  claimTotalTaxAmount: 'Montant total des taxes de la réclamation',
  claimTotalAmountWithTax: 'Montant total de la réclamation avec taxes',
  yourClaimHasBeenSuccessfullySubmitted: 'Votre réclamation a été soumise avec succès !',
  claimJob: 'Travail de réclamation',
  claimJobs: 'Travail de réclamations',
  claimJobNotes: 'Notes du travail de réclamation',
  claimExternalComments: 'Commentaires externes sur la réclamation',
  claimType: 'Type de réclamation',
  optionalClaimType: 'Type de réclamation (facultatif)',
  jobNumber: 'Numéro de travail',
  amountClaimed: 'Montant réclamé',
  claimPaymentEmail: 'E-mail de paiement de la réclamation',
  reportSettings: 'Paramètres du rapport',
  aggregate: 'Agrégat',
  document: 'Document',
  documents: 'Documents',
  dates: 'Dates',
  dealers: 'Concessionnaires',
  dealerGroup: 'Groupe de concessionnaires',
  dealerCost: 'Coût du concessionnaire',
  contractNumber: 'Num. du Contrat',
  contractCreatorSuccessfullyChanged: 'Le créateur du contrat a été modifié avec succès',
  vin: 'NIV',
  contractNumberOrVinRequired: 'Entrez le Num. du Contrat ou le NIV complet pour rechercher des contrats',
  vinMustBeAtLeast8CharsLong: 'Le numéro NIV doit comporter au moins 8 caractères.',
  clientName: 'Nom du client',
  status: 'Statut',
  expiryDate: "Date d'expiration",
  actions: 'Action',
  select: 'Sélectionner',
  unselect: 'Désélectionner',
  sortBy: 'Trier par',
  filterBy: 'Filtrer par',
  lossCode: 'Code de perte',
  lossCodeCategory: 'Catégorie du code de perte',
  lossCodeCategories: 'Catégories de codes de perte',
  categoryNameEn: 'Nom de la catégorie (En)',
  categoryNameFr: 'Nom de la catégorie (Fr)',
  lossCodeSection: 'Section',
  otherSublet: 'Autre/Sous-traitance',
  internalOnly: 'Interne uniquement',
  internalOnlyInfo: 'Masqué dans les formulaires de réclamation des concessionnaires et publics',
  lossCodeDisabledInfo: 'Masqué partout où les codes de perte peuvent être sélectionnés',
  lossCodesImportExcel: 'Importer les codes de perte',
  code: 'Code',
  sectionCode: 'Code de section',
  descnEn: 'DescnEn',
  descFr: 'DescFr',
  english: 'Anglais',
  french: 'Français',
  back: 'Retour',
  noCategory: 'Aucune catégorie',
  selectTypeCodeToSeeLossCodes: 'Sélectionnez un code de type pour voir les codes de perte disponibles',
  descnEn1: 'DescnEn1',
  componentId: 'ID du composant',
  product: 'Produit',
  productName: 'Nom du produit',
  productEnhancement: 'Amélioration du produit',
  productEnhancements: 'Améliorations du produit',
  cloneProduct: 'Cloner le produit',
  clone: 'Cloner',
  cloneProductEnhancement: 'Cloner l’amélioration du produit',
  body: 'Carrosserie',
  provider: 'Fournisseur',
  providers: 'Fournisseurs',
  products: 'Produits',
  example: 'Exemple',
  requiredFilesForTheFollowingDocs: 'Fichiers requis pour les documents suivants',
  allowMultiple: 'Autoriser plusieurs',
  required: 'Requis',
  allowNotes: 'Autoriser les notes',
  approvalRequired: 'Approbation requise',
  totalAggregate: 'Total agrégé',
  totalAggregatePriority: 'Priorité du total agrégé',
  maxClaimAmount: 'Montant maximal de la réclamation',
  maxClaimAmountPriority: 'Priorité du montant maximal de la réclamation',
  maxNumberOfClaims: 'Nombre maximal de réclamations',
  maxNumberOfClaimsPriority: 'Priorité du montant maximal de réclamation',
  amount: 'Montant',
  oldAmount: 'Ancienne montant',
  priority: 'Priorité',
  insurer: 'Assureur',
  isActive: 'Est actif',
  isPayable: 'Est payable',
  isReceivable: 'Est recevable',
  paymentAlreadySent: 'Paiement déjà envoyé',
  notSent: 'Non envoyé',
  createdOn: 'Créé le',
  automation: 'Automatisation',
  qty: 'Quantité',
  overrideClaimRule: 'Outrepasser la règle de réclamation',
  overridePrimaryPayee: 'Remplacer le bénéficiaire principal',
  overridePrimaryPayeeWith: 'Remplacer le bénéficiaire principal par',
  overridePayee: 'Remplacer le bénéficiaire',
  overridePayeeWith: 'Remplacer le bénéficiaire par',
  notAvailable: 'Non disponible',
  claimRule: 'Règle de réclamation',
  useCurrentClaimRule: "Règle de réclamation actuelle de l'utilisateur",
  insurers: 'Les assureurs',
  version: 'Version',
  versions: 'Versions',
  noOfClaims: 'Nombre de réclamations',
  newRepairVisit: 'Nouvelle visite de réparation',
  serviceDetails: 'Détails du service',
  contract: 'Contrat',
  contactInfo: 'Informations de contact',
  class: 'Classe',
  contracts: 'Contrats',
  myContracts: 'Mes contrats',
  otherDealerContracts: 'Recherche de contrat',
  quote: 'Soumission',
  quotes: 'Soumissions',
  vehicleModel: 'Modèle de véhicule',
  vehicleClass: 'Classe de véhicule',
  vehicleModels: 'Modèles de véhicules',
  vehicleClassCopy: 'Copier la classe du véhicule',
  vehicleClasses: 'Classes de véhicules',
  vehicleClassCopyFrom: 'Copie de la classe de véhicule',
  vehicleClassCopyTo: 'Copier vers la classe de véhicule',
  copy: 'Copie',
  vehicle: 'Véhicule',
  vehicles: 'Véhicules',
  customer: 'Client',
  save: 'Sauver',
  jobs: 'Travaux',
  causeOfFailure: "Cause de l'échec",
  customerComplaint: 'Plainte du client',
  customerConcern: 'Préoccupation du client',
  correctionDetails: 'Détails de la correction',
  newJob: 'Nouveau travail',
  job: 'Travail',
  client: 'Client',
  clients: 'Clients',
  vertaforeCustomerNumber: 'Numéro de client Vertafore',
  hasVertaforeCustomerNumber: 'Possède un numéro de client Vertafore',
  syncWithVertafore: 'Synchronisation avec Vertafore',
  syncAllWithVertafore: 'Synchronisez tout avec Vertafore',
  syncedWithVertafore: 'Synchronisé avec Vertafore',
  syncedWithVertaforeStatus: 'Synchronisé avec Vertafore - {{status}}',
  syncWithVertaforeStatus: 'Synchronisation avec Vertafore - {{status}}',
  successfullySyncedWithVertafore: 'Synchronisé avec succès avec Vertafore',
  syncContractWithVertafore: 'Synchroniser le contrat avec Vertafore',
  syncContractDocumentationAggregateWithVertafore: 'Synchroniser les documents contractuels agrégés avec Vertafore',
  syncAllContracts: 'Synchroniser tous les contrats',
  syncAllContractsDocuments: 'Synchroniser tous les documents contractuels',
  contractsDocumentationAggregate: 'Contrats docum. agg.',
  whoIsSubmittingTheClaim: 'Qui soumet la réclamation',
  dataPoints: 'Points de données',
  sendDocumentToDocusign: 'Envoyer le document à DocuSign',
  contractOptions: 'Options du contrat',
  documentSigning: 'Signature du document',
  documentSigningType: 'Type de signature du document',
  documentSigningTypeRequiredForSigning:
    "Le type de signature du document est requis lorsque l'envoi pour signature est activé",
  changeDocumentSigningType: 'Changer le fournisseur de signature',
  changeDocumentSigningTypeWarning:
    'Êtes-vous sûr de vouloir changer le fournisseur de signature ? Les données de signature précédentes pourraient être perdues.',
  SignFlow: 'SignFlow',
  storedInBMS: 'Stocké dans le BMS',
  sendSigningEmailCarbonCopy: "Envoyer une copie carbone de l'e-mail de signature",
  isMappingProductForLegacyContracts: 'Utiliser comme produit de cartographie pour les contrats hérités',
  searchLocation: 'Emplacement de recherche',
  contactClientAndVehicleInfo: 'Contrat',
  partNumber: 'N° de pièce',
  reason: 'Raison',
  payee: 'Bénéficiaire',
  payeeName: 'Bénéficiaire nom',
  notes: 'Notes',
  distributors: 'Distributeurs',
  base: 'Base',
  distributor: 'Distributeur',
  correction: 'Correction',
  adjudication: 'Arbitrage',
  typeCode: 'Type de code',
  paymentMethod: 'Mode de paiement',
  lifecycleStatus: 'Statut du cycle de vie',
  logicStatus: 'Statut logique',
  evidenceSource: 'Source de preuve',
  legacyId: 'Identifiant hérité',
  createdBy: 'Créé par',
  modifiedBy: 'Modifié par',
  total: 'Total',
  claims: 'Réclamations',
  claimTypes: 'Types de réclamations',
  lossCodes: 'Codes de perte',
  settings: 'Paramètres',
  currency: 'Devise',
  parts: 'Pièces',
  labour: "Main-d'œuvre",
  labourRate: "Taux de main-d'œuvre",
  overrideLabour: 'Remplacer la main-d’œuvre',
  other: 'Autre',
  ttl: 'Total (avant taxes)',
  deduct: 'Déduire',
  paidAmount: 'Montant payé',
  clickOrDropFilesHere: 'Cliquez ou déposez les fichiers ici',
  files: 'Fichiers',
  allowed: 'Autorisé',
  fileUploadSize: 'Taille maximale du fichier à téléverser',
  uploadError: 'Erreur de téléchargement',
  done: 'Fait/Terminé',
  justAMoment: 'Juste un instant',
  approved: 'Approuvé',
  pleaseSaveClaimJobsToUploadDocuments:
    'Veuillez enregistrer les travaux de réclamation pour télécharger les documents',
  createSimpleClaim: 'Créer une réclamation simple',
  add: 'Ajouter',
  addPlaceholder: 'Ajouter un espace réservé',
  addEmailTemplatePlaceholder: "Puis choisissez le texte d'espace réservé souhaité.",
  totalTax: 'Total des taxes',
  type: 'Type',
  address: 'Adresse',
  payeeTypes: 'Types de bénéficiaires',
  payeeType: 'Type de bénéficiaire',
  payeeEmail: 'Adresse e-mail du bénéficiaire',
  payeeAddress: 'Adresse du bénéficiaire',
  dealer: 'Concessionnaire',
  streetNumber: 'Numéro de rue',
  streetName: 'Nom de la rue',
  postalCode: 'Code postal',
  zipCode: 'Code ZIP',
  state: 'État',
  muncipality: 'Municipalité',
  provinceCode: 'Code de province',
  countryCode: 'Code du pays',
  uploadedWithSimpleClaim: 'Télécharger avec une réclamation simple',
  new: 'Nouvelle',
  expiryFromDate: 'Date d’expiration – à partir de',
  expiryToDate: 'Date d’expiration – jusqu’à',
  invoicingDate: 'Date de facturation',
  invoicingFromDate: 'Date de facturation – à partir de',
  invoicingToDate: 'Date de facturation – jusqu’à',
  effectiveFromDate: 'Date d’entrée en vigueur – à partir de',
  effectiveToDate: 'Date d’entrée en vigueur – jusqu’à',
  createdAtFromDate: 'Créé à partir de la date',
  createdAtToDate: 'Créé à ce jour',
  modifiedAtFromDate: 'Modifié à partir de la date',
  modifiedAtToDate: 'Modifié à ce jour',
  reconciledAt: 'Réconcilié le',
  reconciledBy: 'Réconcilié par',
  expiresAtFromDate: 'Expire à partir de la date',
  expiresAtToDate: 'Expire à ce jour',
  newTotalAmount: 'Nouveau montant total',
  priorTotalAmount: 'Montant total précédent',
  exclusions: 'Exclusions',
  gallery: 'Galerie',
  showGallery: 'Afficher la galerie',
  fromDate: 'À partir de la date',
  toDate: 'À ce jour',
  lastModified: 'Dernière modification',
  youWillKeepOwnership: 'Vous conserverez la propriété',
  ownershipWillBeRemoved: 'La propriété sera supprimée',
  takeOwnershipOfTheClaim: 'Prendre possession de la réclamation',
  transferOwnershipTo: 'Transférer la propriété à',
  firstModified: 'Première modification',
  ascendingByName: 'Croissant par nom',
  descendingByName: 'Décroissant par nom',
  pleaseEnterRequiredInfoBellow: 'Veuillez entrer les informations requises ci-dessous',
  noStatusDefined: 'Aucun statut défini',
  statusError: 'Erreur de statut',
  edit: 'Modifier',
  ban: 'Interdire',
  chooseExisting: "Choisir l'existant",
  unitNumber: "Numéro d'unité",
  appNumber: "Numéro d'application",
  taxExempt: 'Exonéré de taxes',
  taxExemptionBand: "Tranche d'exonération fiscale",
  calculation: 'Calcul',
  unknownUser: 'Utilisateur inconnu',
  clear: 'Effacer',
  clearAddress: 'Effacer l’adresse',
  makeCode: 'Code de marque',
  alternativeMakeCode: 'Code de marque alternatif',
  model: 'Modèle',
  year: 'Année',
  bodyType: 'Type de carrosserie',
  noOwnership: 'Aucune propriété',
  open: 'Ouverte',
  addComent: 'Ajouter un commentaire',
  changeStatus: 'Changer de statut',
  likes: 'Goûts',
  like: 'Comme',
  dislike: 'Aversion',
  edited: 'Modifié',
  changeOwner: 'Changer de propriétaire',
  welcomeToAutoshieldCanada: 'Bienvenue chez Auto Shield Canada',
  descriptionOfDamage: 'Description des dommages',
  repairFacility: 'Atelier de réparation',
  phoneNumber: 'Numéro de téléphone',
  iAmCreatingClaimAsRepairFacility: 'Je crée une réclamation en tant qu’atelier de réparation',
  contactName: 'Nom du contact',
  contactEmail: 'Courriel du contact',
  contact: 'Contact',
  emailTemplates: "Modèles d'e-mails",
  emailTemplate: "Modèle d'e-mail",
  claimStatus: 'Statut de la réclamation',
  claimJobStatus: 'Statut du travail de réclamation',
  claimStatusSuccesfullyChanged: 'Le statut de la réclamation a été modifié avec succès',
  contractStatusSuccesfullyChanged: 'Le statut du contrat a été modifié avec succès',
  senderEmail: "E-mail de l'expéditeur",
  senderName: "Nom de l'expéditeur",
  subject: 'Sujet',
  htmlBody: 'Corps HTML',
  recipientsWithRole: 'Destinataires avec rôle',
  payeeRequired: 'Le bénéficiaire est requis',
  payees: 'Bénéficiaires',
  sourceAndLogs: 'Source et journaux',
  logs: 'Journaux',
  saveSuccess: 'Le formulaire a été enregistré avec succès',
  saveError: "Une erreur s'est produite lors de l'enregistrement du formulaire",
  importSuccess: 'Importation terminée avec succès !',
  importError: "Une erreur s'est produite lors de l'importation du fichier !",
  exportSuccess: 'Exportation terminée avec succès !',
  exportError: "Une erreur s'est produite lors de l'exportation du fichier !",
  export: 'Exporter',
  exportPrices: 'Exporter les prix',
  dontSendEmail: '"""N\'envoyez pas d\'e-mail"""',
  additionalRecipientEmails: 'E-mails de destinataires supplémentaires',
  noChangesWereMade: "Aucune modification n'a été apportée",
  claimOwner: 'Propriétaire de la réclamation',
  sendTo: 'Envoyer à',
  sendCCTo: 'Envoyer CC à',
  addNote: 'Ajouter une note',
  isForNewVehicle: 'Est pour un nouveau véhicule',
  isNew: "C'est nouveau",
  pending: 'En attente',
  effectiveDate: "Date d'entrée en vigueur",
  dateOfLoss: 'Date de la perte',
  typeOfLoss: 'Type de perte',
  dealership: 'Concessionnaire',
  lender: 'Prêteur',
  classes: 'Classes',
  comment: 'Commentaire',
  mailingAddress: 'Adresse postale',
  preOwnedVehicle: "Véhicule d'occasion",
  preOwned: "D'occasion",
  claimIndemnityCalculation: "Calcul de l'indemnité de sinistre",
  productCategory: 'Catégorie de produit',
  tier: 'Niveau/Tier',
  primaryCode: 'Code principal',
  tiers: 'Niveaux',
  secondaryCode: 'Code secondaire',
  models: 'Modèles',
  report: 'Rapport',
  totalAmountWithTaxes: 'Montant total avec taxes',
  totalAmountWithoutTaxes: 'Montant total hors taxes',
  taxes: 'Taxes',
  consentResponseWindowExpired:
    'Le délai pour répondre au consentement est expiré. Veuillez contacter la personne autorisée pour demander un nouvel envoi.',
  consentLinkInvalidOrExpired:
    'Ce lien est invalide ou a expiré. Veuillez contacter la personne autorisée pour demander un nouvel envoi.',
  consentResponseFailed: "Nous n'avons pas pu traiter votre réponse. Veuillez réessayer plus tard.",
  vehicleMake: 'Marque du véhicule',
  noNotes: 'Aucune note',
  totalAmount: 'Montant total',
  totalAmountNoTax: 'MontantTotal (hors taxes)',
  addition: 'Addition',
  subtraction: 'Soustraction',
  noComments: 'Aucun commentaire',
  pleaseSaveJobToAddNotes: 'Veuillez enregistrer le travail pour ajouter des notes',
  multiplication: 'Multiplication',
  division: 'Division',
  percent: 'Pourcentage',
  label: 'Étiquette',
  key: 'Clé',
  isHighlighted: 'Est mis en évidence',
  summationOperation: 'Opération de sommation',
  totalAmountOperation: "Montant total de l'opération",
  secondaryValue: 'Valeur secondaire',
  primaryValue: 'Valeur principale',
  totalValue: 'Valeur totale',
  value: 'Valeur',
  askForInput: 'Demander des commentaires',
  copyValue: 'Copier la valeur',
  sumValues: 'Valeurs SOMME',
  primaryUsage: 'Utilisation principale',
  row: 'Rangée',
  price: 'Prix',
  preview: 'Aperçu',
  alreadyExists: 'Existe déjà',
  unknownProduct: 'Produit inconnu',
  noContractDefined: 'Aucun contrat défini',
  mustSelectAtleastOneOption: 'Vous devez sélectionner au moins une option',
  selectLanguage: 'Choisissez la langue',
  newlyCreated: 'Nouvellement créé',
  pricingLimitTemplate: 'Modèle de limite de prix',
  pricingLimitTemplates: 'Modèles de limites de prix',
  cannotBeNegativeNumber: 'Ne peut pas être un nombre négatif',
  maxKm: 'Max KM',
  saveDraft: 'Enregistrer le brouillon',
  minPrice: 'Prix minimum',
  deleteDraft: 'Supprimer le brouillon',
  customInfo: 'Informations sur les prix',
  customInfoGroup: "Groupe d'informations sur les prix",
  maxPrice: 'Prix maximum',
  noJobs: 'Aucun travail',
  drafts: 'Brouillons',
  unknown: 'Inconnu',
  propertyPathRequired: 'Chemin de propriété requis',
  wereSuccessfullyDeleted: '{{entity}} ont été supprimés avec succès',
  wereSuccessfullyUploaded: '{{entity}} ont été téléchargés avec succès',
  productDocumentDeleteSubmitMessage:
    'Voulez-vous vraiment supprimer ce document produit ainsi que tous les documents de concessionnaires et de groupes de concessionnaires qui y sont associés?',
  productDealerDocumentDeleteSubmitMessage:
    'Êtes-vous sûr de vouloir supprimer {{numberOfDocuments}} documents produit ?',
  productDocuments: 'Documents produits',
  productDocs: 'Documentation du produit.',
  enhDocs: 'Enh. doc.',
  productEnhancementDocuments: "Documents d'amélioration du produit",
  productEnhancementDocs: "Documents d'amélioration du produit",
  documentsSigned: 'Documents signés',
  documentsSentForSigning: 'Documents envoyés pour signature',
  pricingPlan: 'Plan tarifaire',
  distributorDistributions: 'Distributions des distributeurs',
  distributions: 'Distributions',
  enhancementsDistributions: "Distributions d'améliorations",
  productsDistributions: 'Distributions de produits',
  contractUnrestrictedUpdateWarningMessage:
    "Veuillez accéder à l'onglet DOCUMENTS où vous pouvez éventuellement générer de nouveaux documents et les envoyer pour signature.",
  contractUnrestrictedUpdateDistributionsErrorMessage:
    'Veuillez noter que les modifications des montants de distribution ne mettront pas automatiquement à jour les montants indiqués ci-dessous, et inversement.',
  distributorPricing: 'Tarification des distributeurs',
  pricingPlans: 'Plans tarifaires',
  revisions: 'Révisions',
  additionalRow: 'Ligne supplémentaire',
  minOdometer: 'Lecture minimale du compteur kilométrique',
  generated: 'Généré',
  contractDocument: 'Document contractuel',
  changeContractStatus: 'Modifier le statut du contrat',
  changeContractCreator: 'Changer le créateur du contrat',
  documentUpload: 'Téléchargement de documents',
  vehicleYear: 'Année du véhicule',
  maxOdometer: 'Lecture maximale du compteur kilométrique',
  table: 'Tableau',
  suggestedRetailPrice: 'Prix de détail suggéré',
  sugRetailPrice: 'Prix de détail suggéré',
  documentationAggregate: 'Documentation agrégée',
  documentationTranslationAggregate: 'Documentation traductions agrégée',
  generate: 'Générer',
  copyDefaultPricesHere: 'Copiez les prix par défaut ici',
  pricingDistributionTemplates: 'Modèles de distribution des prix',
  pricingDistributionTemplate: 'Modèle de distribution des prix',
  pricingDistributionMasterTemplates: 'Modèles maîtres de répartition des prix',
  pricingDistributionMasterTemplate: 'Modèle maître de répartition des prix',
  openPricingDistributionTable: 'Ouvrir le tableau de distribution des prix',
  openSubfeeDistributionTable: 'Ouvrir le tableau de distribution des sous-frais',
  openDealerDistributionDiscountTable: 'Ouvrir le tableau des remises distribution des concessionnaire',
  openDealerDistributorDistributionDiscountTable: 'Ouvrir le tableau des remises distribution des distributeurs',
  surcharge: 'Surtaxe',
  contractSubmitMessage: 'Êtes-vous sûr d’être prêt à soumettre ce contrat ?',
  surcharges: 'Suppléments',
  quantity: 'Quantité',
  contractDocuments: 'Documents contractuels',
  logo: 'Logo',
  logoFr: 'Logo (Français)',
  profileImage: 'Image de profil',
  notification: 'Notification',
  isPackage: "Ce produit fait partie d'un package",
  invalidFormatRequires: 'Format invalide',
  documentsGenerated: 'Documents générés',
  documentTemplates: 'Modèles de documents',
  contractStatusWaiting: 'En attente',
  contractStatusSaving: 'Enregistrement en cours',
  contractStatusGeneratingDocs: 'Génération de documents',
  contractStatusSendingConsent: 'Envoi du consentement',
  contractStatusConsentSentFailed: "Échec de l'envoi du consentement",
  contractStatusConsentSent: 'Consentement envoyé',
  contractStatusUploadingFiles: 'Téléchargement de fichiers',
  publicClaimCreationWarning: `La modification du champ 'Qui soumet la réclamation' supprimera toutes les données déjà saisies dans le formulaire !`,
  contractStatusDone: 'Fait/Terminé',
  contractStatusFailed: 'Échoué',
  remove: 'Retirer',
  autoFilledDocuments: 'Documents remplis automatiquement',
  transferDocuments: 'Documents de transfert',
  transferDocument: 'Document de transfert',
  mainDistributorUser: 'Utilisateur distributeur principal',
  mainDistributorRepresentative: 'Représentant principal du distributeur',
  youveBeenRemovedFromClaimBy: '« Vous avez été retiré de la réclamation par »',
  uiSettings: "Paramètres de l'interface utilisateur",
  notAllRequiredDocumentInfoWasProvided: "Toutes les informations requises sur les documents n'ont pas été fournies",
  signerSource: 'Source du signataire',
  enabled: 'Activé',
  disabled: 'Désactivé',
  enable: 'Activer',
  disable: 'Désactiver',
  signature: 'Signature',
  routingOrder: 'Ordre de routage',
  invoices: 'Factures',
  invoice: 'Facture',
  invoiceNumber: 'Numéro de facture',
  invoiceDate: 'Date de la facture',
  documentType: 'Type de document',
  fileName: 'Nom de fichier',
  documentName: 'Nom du document',
  repairs: 'Réparations',
  inServiceDate: 'Date de mise en service',
  vehicleOriginalInServiceDate: "Date de mise en service d'origine du véhicule",
  mfgWholeVehicleWarranty: 'Garantie complète du véhicule',
  mfgPowertrainWarranty: 'Garantie du groupe motopropulseur',
  mfgWholeVehicleWarrantyMonths: 'Mois de garantie complète du véhicule',
  mfgPowertrainWarrantyMonths: 'Mois de garantie du groupe motopropulseur',
  mfgWholeVehicleWarrantyKm: 'KM de garantie complète',
  mfgPowertrainWarrantyKm: 'Garantie du groupe motopropulseur km',
  warrantyOptions: 'Options de garantie',
  options: 'Options',
  canSellPostSale: 'Peut vendre après la vente',
  markContractAsPostSale: 'Marquer le contrat comme après-vente',
  isWarrantyDetailsVisible: 'Afficher les détails de la garantie',
  isPurchaseDetailsVisible: "Afficher les détails de l'achat",
  coverageKm: 'Couverture Km',
  maxCoverageKm: 'Couverture maximale km',
  isPartOfPackage: 'Fait partie du package',
  isCustomerConsentRequired: 'Le consentement du client est-il requis ?',
  customerConsentSent: 'Consentement du client envoyé',
  part: 'Pièce',
  create: 'Créer',
  areDocumentsAutomaticallySentForSigning: 'Les documents sont automatiquement envoyés pour signature',
  jobDetails: 'Détails du travail',
  clientInfo: 'Infos client',
  warrantyOption: 'Option de garantie',
  postSale: 'Après-vente',
  totalPrice: 'Prix total',
  sign: 'Signer',
  draft: 'Brouillon',
  reconciled: 'Rapproché',
  preliminary: 'Préliminaire',
  canceled: 'Annulé',
  cancelled: 'Annulé',
  signAndPay: 'Signer et payer',
  readyForSign: 'Prêt à signer',
  paymentRequired: 'Paiement requis',
  paymentNotRequired: 'Paiement non requis',
  deliveryDate: 'Date de livraison',
  currentTotal: 'Total actuel',
  sellingDealership: 'Concessionnaire vendeur',
  asc: 'ASC',
  loadLogs: 'Charger les journaux',
  publicLink: 'Lien public',
  termInMonths: 'Durée en mois',
  posOdometerReading: 'Lecture odomètre POS',
  enhancements: 'Améliorations',
  view: 'Voir',
  text: 'Texte',
  alphanumeric: 'Alphanumérique',
  any: 'N’importe quel',
  lastJobStatus: 'Dernier statut du travail',
  date: 'Date',
  boolean: 'Booléen',
  dateTime: 'Date et heure',
  oldValue: 'Ancienne valeur',
  newValue: 'Nouvelle valeur',
  dealerCostPrice: 'Coût d’achat concessionnaire',
  insurancePremium: 'Prime d’assurance',
  administrationFee: 'Frais d’administration',
  administrationFeeTax: 'Taxe sur les frais d’administration',
  administrationFeeTaxRate: 'Taux de taxe sur les frais d’administration',
  limitOfLiability: 'Limite de responsabilité',
  totalRetailPrice: 'Prix de vente total',
  customerName: 'Nom du client',
  customerEmail: 'Email du client',
  dealerReferralFee: 'Frais de référencement du concessionnaire',
  video: 'Vidéo',
  customerAcceptance: 'Acceptation du client',
  acceptOffer: "Accepter l'offre",
  decline: 'Refuser',
  accept: 'Accepter',
  licenseNumber: 'Numéro de licence',
  coverage: 'Couverture',
  paid: 'Payé',
  unpaid: 'Non payé',
  denied: 'Refusé',
  cheque: 'Chèque',
  eTransfer: 'Virement électronique',
  eft: 'Virement électronique',
  emailSent: 'Email envoyé',
  readyForPayment: 'Prêt pour le paiement',
  signed: 'Signé',
  waitingForSignatures: 'En attente des signatures',
  signatureRequired: 'Signature requise',
  signatureNotRequired: 'Signature non requise',
  hours: 'Heures',
  emails: 'Courriels',
  sendDate: "Date d'envoi",
  includeDistributorPricing: 'Inclure les prix du distributeur',
  sendEmail: 'Envoyer un e-mail',
  sendEmails: 'Envoyer des e-mails',
  sendConsent: 'Envoyer le consentement',
  consent: 'Consentement',
  consentRequired: 'Consentement requis',
  thankYouForYourResponse: 'Merci pour votre réponse',
  youAlreadySubmittedYourResponseForThisConsent: 'Vous avez déjà soumis une réponse pour ce consentement !',
  limitOfLiabilityAggregate: 'Limite de responsabilité globale',
  yourConsentIsProcessedForContractAppNumber: 'Votre consentement est valide {{status}}',
  yourConsentIsProcessed: 'Votre consentement est valide {{status}}',
  resendConsent: 'Renvoyer le consentement',
  manuallyAcceptConsent: 'Accepter manuellement le consentement',
  mustBeEmailDomain: 'Le domaine de l’email doit être {domain}',
  emailHistory: 'Historique des e-mails',
  requestedAmount: 'Montant demandé',
  adjustedAmount: 'Montant ajusté',
  archive: 'Archiver',
  unarchive: 'Désarchiver',
  withArchived: 'Avec archivage',
  withInactive: 'Avec inactif',
  inactive: 'Inactif',
  active: 'Actif',
  without: 'Sans',
  productReportRecipients: 'Destinataires du rapport produit',
  productReportRecipient: 'Destinataire du rapport produit',
  reportRecipients: 'Destinataires du rapport',
  reportRecipient: 'Destinataire du rapport',
  reportsEnabled: 'Rapports activés',
  reportTo: 'Destinataire',
  hasLegacyId: 'A un identifiant hérité',
  workOrderNumber: 'Numéro de bon de travail',
  supportDeskId: "Identifiant du service d'assistance",
  hasDealerDocument: 'A un document du concessionnaire',
  emailSuccessfullySent: "L'e-mail a été envoyé avec succès",
  documentExistsForThisLang: 'Un document existe déjà pour cette langue',
  textSuccessfullySent: 'Le texte a été envoyé avec succès',
  unableToSendEmail: "Nous ne pouvons pas envoyer d'e-mail pour le moment",
  sendResetPasswordEmail: 'Envoyer un e-mail de réinitialisation du mot de passe',
  public: 'Publique',
  exempt: 'Exempter',
  createdAtLocal: 'Créé localement',
  chooseExistingRepairFacility: 'Choisissez un centre de réparation existant',
  adjustDistributions: 'Ajuster les distributions',
  //Product type
  'WARRANTY_TIER-BASED': 'Garantie - Tarification par niveau',
  'WARRANTY_CLASS-BASED': 'Garantie - Tarification basée sur la classe',
  'NON-WARRANTY': 'Tarifs hors garantie',
  CUSTOM: 'Tarification personnalisée',
  editContractUnrestricted: 'Modifier le contrat sans restriction',
  //Permissions
  IMPORT_VEHICLEMAKE_FROM_EXCEL: 'Importer la marque du véhicule depuis Excel',
  IMPORT_LOSSCODE_FROM_EXCEL: 'Importer le code de perte depuis Excel',
  CREATE_ROLE: 'Créer un rôle',
  EDIT_ROLE: 'Modifier le rôle',
  DELETE_ROLE: 'Supprimer le rôle',
  UPLOAD_DOCUMENTS_CONTRACT: 'Télécharger le document contractuel',
  CREATE_CONTRACT: 'Créer un contrat',
  EDIT_CONTRACT: 'Modifier le contrat',
  EDIT_CONTRACT_UNRESTRICTED: 'Modifier le contrat (sans restriction)',
  RESTRICT_EFFECTIVE_DATE_TO_5_DAY_THRESHOLD: 'Restreindre la date d’entrée en vigueur à un seuil de 5 jours',
  CREATE_EMAILTEMPLATE: "Créer un modèle d'e-mail",
  EDIT_EMAILTEMPLATE: "Modifier le modèle d'e-mail",
  DELETE_EMAIL_TEMPLATE: "Supprimer le modèle d'e-mail",
  DELETE_CONTRACT: 'Supprimer le contrat',
  VIEW_PERMISSION: 'Voir la permission',
  VIEW_CATEGORY: 'Voir la catégorie',
  VIEW_APPLICATION: "Voir l'application",
  CREATE_USER: 'Créer un utilisateur',
  EDIT_USER: "Modifier l'utilisateur",
  DELETE_USER: "Supprimer l'utilisateur",
  passwordValidityMessage: '"Le mot de passe doit comporter au moins 7 caractères',
  RESET_PASSWORD: 'Réinitialiser le mot de passe',
  VIEW_ACCESSLOGS: 'Voir les journaux d’accès',
  VIEW_AUDITLOGS: 'Voir les journaux de modifications',
  CREATE_CLAIM: 'Créer une réclamation',
  CLAIM_ADMIN: 'Réclamation administrative',
  EDIT_CLAIM: 'Modifier la réclamation',
  DELETE_CLAIM: 'Supprimer la réclamation',
  CREATE_CLAIMTYPE: 'Créer un type de réclamation',
  EDIT_CLAIMTYPE: 'Modifier le type de réclamation',
  DELETE_CLAIMTYPE: 'Supprimer le type de réclamation',
  CREATE_LOSSCODE: 'Créer un code de perte',
  EDIT_LOSSCODE: 'Modifier le code de perte',
  DELETE_LOSSCODE: 'Supprimer le code de perte',
  CREATE_PRODUCT: 'Créer un produit',
  EDIT_PRODUCT: 'Modifier le produit',
  DELETE_PRODUCT: 'Supprimer le produit',
  EXTERNAL_COMMENT: 'Commentaires externes',
  INTERNAL_COMMENT: 'Commentaires internes',
  DELETE_PAYEE: 'Supprimer le bénéficiaire',
  EDIT_PAYEE: 'Modifier le bénéficiaire',
  CREATE_PAYEE: 'Créer un bénéficiaire',
  CREATE_PRICINGLIMITTEMPLATE: 'Voir le modèle de limite de prix',
  EDIT_PRICINGLIMITTEMPLATE: 'Modifier le modèle de limite de prix',
  DELETE_PRICINGLIMITTEMPLATE: 'Supprimer le modèle de limite de prix',
  CREATE_PRICINGPLAN: 'Voir le plan tarifaire',
  EDIT_PRICINGPLAN: 'Modifier le plan tarifaire',
  DELETE_PRICINGPLAN: 'Supprimer le plan tarifaire',
  //Dates
  dayOfWeek: 'Jour de la semaine',
  timeAndPlace: 'Heure et lieu',
  time: 'Heure',
  dateAndTime: 'Date et heure',
  monday: 'Lundi',
  tuesday: 'Mardi',
  wednesday: 'Mercredi',
  thursday: 'Jeudi',
  friday: 'Vendredi',
  saturday: 'Samedi',
  sunday: 'Dimanche',
  mon: 'Lun',
  tue: 'Mar',
  wed: 'Mer',
  thu: 'Jeu',
  fri: 'Ven',
  sat: 'Sam',
  sun: 'Dim',
  january: 'Janvier',
  february: 'Février',
  march: 'Mars',
  april: 'Avril',
  may: 'Mai',
  june: 'Juin',
  july: 'Juillet',
  august: 'Août',
  september: 'Septembre',
  october: 'Octobre',
  november: 'Novembre',
  december: 'Décembre',
  jan: 'Jan',
  feb: 'Fév',
  mar: 'Mar',
  apr: 'Avr',
  jun: 'Juin',
  jul: 'Juillet',
  aug: 'Août',
  sep: 'Sep',
  oct: 'Octobre',
  nov: 'Nov',
  dec: 'Déc',
  passwordWasSuccessfullySet: 'Le mot de passe a été défini avec succès',
  weWereUnableToSetYourPassword: "Nous n'avons pas pu définir votre mot de passe",
  minPurchasePriceCAD: "Prix d'achat minimum",
  maxPurchasePriceCAD: "Prix d'achat maximum",
  minFinancedAmountCAD: 'Montant minimum financé',
  maxFinancedAmountCAD: 'Montant maximal financé',
  productCustomPricePoint: 'Groupe de prix personnalisé',
  image: 'Image',
  images: 'Images',
  alreadyAdded: 'Déjà ajouté',
  replaceFile: 'Remplacer le fichier',
  latestNote: 'Dernière note',
  isAutomaticStatementEnabled: 'Le paiement automatique est-il activé',
  cannotSelectMoreThanOneCandidate: 'Impossible de sélectionner plus d’un candidat',
  isAutomaticPreliminaryStatementEnabled: 'Le paiement préliminaire automatique',
  isAutomaticStatementBalanceEnabled: 'Le relevé automatique',
  getLegacyContractDocument: 'Obtenir le document du contrat hérité',
  allowManualJobItems: 'Autoriser les éléments de travail manuels',
  downloadWasSuccessful: 'Le téléchargement a réussi',
  goHome: 'Accueil',
  showMyClaims: 'Voir mes réclamations',
  resetStatus: 'Réinitialiser l’état',
  authorizationNumber: 'Auth #',
  uploadDocumentTranslation: 'Téléverser la traduction',
  translations: 'Traductions',
  claimsPaymentPending: 'Paiements de réclamation en attente',
  claimsPaymentHistory: 'Historique des paiements de réclamation',
  contractsPaymentPending: 'Paiements de contrats en attente',
  contractsPaymentHistory: 'Historique des paiements de contrats',
  paymentItem: 'Élément de paiement',
  deleteAllPendingItemsForThisRefund: 'Supprimer tous les éléments en attente de ce remboursement',
  areYouSureYouWantToDeleteAllPendingItemsForThisRefund:
    'Êtes-vous sûr de vouloir supprimer tous les éléments de paiement en attente pour ce remboursement? Cela supprime tous les éléments non payés du remboursement, pas seulement celui-ci.',
  referenceNumber: 'Numéro de référence',
  explanation: 'Explication',
  underwriter: 'Souscriptrice',
  transactionDate: 'Date de transaction',
  expiredContractClaimWindowExceeded:
    "La création d'une réclamation n'est pas autorisée plus de 30 jours après l'expiration du contrat",
  unableToProcessPaymentItems:
    'Impossible de traiter la demande car les informations relatives au demandeur, au bénéficiaire ou aux modes de paiement sont différentes.',
  unableToProcessRefundPaymentItems:
    'Impossible de traiter la demande car les informations relatives au contract refund, au bénéficiaire ou aux modes de paiement sont différentes.',
  bankTransit: 'Transit bancaire',
  bankBranch: 'Succursale bancaire',
  bankAccount: 'Compte bancaire',
  chequeNumber: 'Numéro de chèque',
  chequeDate: 'Date du chèque',
  chequeDocument: 'Document de chèque',
  evidenceDocument: 'Document de preuve',
  externalPaymentReference: 'Référence de paiement externe',
  internalPaymentReference: 'Référence de paiement interne',
  paymentTransactionNumber: 'Numéro de transaction de paiement',
  emailAddress: 'Adresse e-mail',
  autoDepositEnabled: 'Dépôt automatique activé',
  eTransferAnswer: 'E-Transfer répondre',
  eTransferQuestion: 'E-Transfer question',
  error: 'Erreur',
  success: 'Succès',
  warning: 'Avertissement',
  remarks: 'Remarques',
  payment: 'Paiement',
  dateCreated: 'Date de création',
  paymentType: 'Type de paiement',
  itemTotal: "Total de l'article",
  totalPaid: 'Total payé',
  paymentInfoDetails: 'Informations de paiement détails',
  transactionNumber: 'Numéro de transaction',

  OPEN: 'OUVERT',
  APPROVED: 'APPROUVÉ',
  PAYMENT_PENDING: 'PAIEMENT EN ATTENTE',
  PAID: 'PAYÉ',
  CANCELLED: 'ANNULÉ',
  RECONCILED: 'RÉCONCILIÉ',
  CANCELED: 'ANNULÉ',
  PRELIMINARY: 'PRÉLIMINAIRE',
  'OPEN_ACTIVE_Submitted - Selling Dealer': 'OUVERT_ACTIF_Soumis - Vendeur Détaillant',
  'OPEN_ACTIVE_Submitted - Dealership': 'OUVERT_ACTIF_Soumis - Concessionnaire',
  'OPEN_ACTIVE_Submitted - RepairFacility': 'OUVERT_ACTIF_Soumis - Atelier de Réparation',
  'OPEN_ACTIVE_Submitted - Customer': 'OUVERT_ACTIF_Soumis - Client',
  'OPEN_ACTIVE_Submitted - Other': 'OUVERT_ACTIF_Soumis - Autre',
  'OPEN_ACTIVE_In Progress': 'OUVERT_ACTIF_En Cours',
  OPEN_PENDING: 'OUVERT_EN-ATTENTE',
  DENIED_DECLINED: 'REFUSÉ_REJETÉ',
  'PAID_CLOSED-PAID': 'PAYÉ_FERMÉ-PAYÉ',
  OPEN_ACTIVE_Pending: 'OUVERT_ACTIF_En attente',
  'OPEN_APPROVED_Waiting On Invoice': 'OUVERT_APPROUVÉ_En attente de la facture',
  'OPEN_APPROVED_Invoice Review - Service': 'OUVERT_APPROUVÉ_Révision de facture - Service',
  'OPEN_APPROVED_Invoice Recieved': 'OUVERT_APPROUVÉ_Facture reçue',
  'OPEN_APPROVED-TO-PAY - By Accounting': 'OUVERT_APPROUVÉ-POUR-PAIEMENT - Par la comptabilité',
  'OPEN_PAID_Payment sent': 'OUVERT_PAYÉ_Paiement envoyé',
  OPEN_SUBMITTED: 'OUVERT_SOUMIS',
  OPEN_DEFERRED: 'OUVERT_REPORTÉ',
  'OPEN_UNDER REVIEW': 'OUVERT_EN EXAMEN',
  OPEN_UNPAID: 'OUVERT_NON PAYÉ',
  'OPEN_WAITING CONSENT': 'OUVERT_EN ATTENTE DE CONSENTEMENT',
  PAID_ACTIVE: 'PAYÉ_ACTIF',
  PAID_EXPIRED: 'PAYÉ_EXPIRÉ',
  CANCELED_VOID: 'ANNULÉ_NUL',
  OPEN_REFUND: 'OUVERT_REMBOURSEMENT',
  PAID_PENDING_REFUND: 'PAYÉ_EN ATTENTE REMBOURSEMENT',
  CANCELED_REFUND: 'ANNULÉ_REMBOURSEMENT',
  CANCELED_PR_REFUND: 'ANNULÉ_REMBOURSEMENT PR',
  'CANCELED_REFUND / PR REFUND': 'ANNULÉ_REMBOURSEMENT / REMBOURSEMENT PR',
  formSuccessAndFilesFailedMessage:
    'Le formulaire a été enregistré avec succès, mais certains fichiers n’ont pas été supprimés ou téléversés!',
  filesUploaded: 'Fichiers téléversés',
  filesGotDeleted: 'Fichiers supprimés',
  ANYSTATUS_SEND_EMAIL: 'TOUTSTATUT_ENVOYER_COURRIEL',
  'ANYSTATUS_Send Invoice': 'TOUTSTATUT_Envoyer Facture',
  'OPEN_PENDING_Send Document': 'OUVERT_EN-ATTENTE_Envoyer Document',
  DISTRIBUTOR_SEND_EMAIL: 'DISTRIBUTEUR_ENVOYER_COURRIEL',
  'Internal Combustion': 'Combustion interne',
  Electric: 'Électrique',
  'Internal Combustion/Electric Hybrid': 'Hybride combustion interne / électrique',
  Gas: 'Essence',
  Hybrid: 'Hybride',
  'Plug-In Hybrid': 'Hybride rechargeable',
  Gasoline: 'Essence',
  Diesel: 'Diesel',
  'Diesel (B20 capable)': 'Diesel (compatible B20)',
  'Flex Fuel': 'Carburant flexible',
  Hydrogen: 'Hydrogène',
  'Natural Gas': 'Gaz naturel',
  Propane: 'Propane',
  'Natural Gas/Propane': 'Gaz naturel/Propane',
  'Gas/Electric Mild Hybrid': 'Hybride essence/électrique léger',
  CLAIMS_REMITTANCE_ADVICE: 'RECLAMATIONS_VERSEMENT_AVIS',
  contractRefundPaymentStatusTrigger: 'Statut du paiement de remboursement de contrat',
  CONTRACT_REFUNDS_REMITTANCE_ADVICE: 'REMBOURSEMENTS_CONTRAT_VERSEMENT_AVIS',
  contractRefundPaymentEmailTemplates: 'Modèles de courriel de paiement de remboursement de contrat',
  regenerateRemittance: 'Régénérer la remise',
  remittanceSuccessfullyGenerated: 'Remise générée avec succès',
  numberOfItems: 'Nombre d’articles',
  ledgerAccountName: 'Nom du compte du grand livre',
  payeePhoneNumber: 'Numéro de téléphone du bénéficiaire',
  refundJobIds: 'Identifiants des tâches de remboursement',
  appNumbers: 'Numéros de demande',
  CSV_UPLOAD: 'TELEVERSEMENT_CSV',
  BANK_API: 'API_BANCAIRE',
  OCR_SERVICE_EMAIL: 'COURRIEL_SERVICE_OCR',
  MAIL_COURIER: 'COURRIER_POSTAL',
  CREATED_BY_USER: 'CREE_PAR_UTILISATEUR',
  RECEIVED: 'RECU',
  ADVISED: 'AVISE',
  ADVISED_MATCHED: 'CONSEILLÉ_CORRESPONDANT',
  ADVISED_UNMATCHED: 'CONSEILLÉ_NON_CORRESPONDANT',
  PROCESSED: 'TRAITE',
  UNMATCHED: 'NON_APPARIE',
  MATCHING_READY: 'PRET_POUR_APPARIEMENT',
  MATCH_CONFIRMED: 'APPARIEMENT_CONFIRME',

  UNKNWON: 'INCONNU',
  NO_UPLOADING: 'AUCUN_TELEVERSEMENT',
  NOT_UPLOADED: 'NON_TELEVERSE',
  UNSIGNED_UPLOADED: 'TELEVERSE_NON_SIGNE',
  SIGNED_UPLOADED: 'TELEVERSE_SIGNE',
  ERROR_CREATE_CLIENT: 'ERREUR_CREATION_CLIENT',
  ERROR_UPLOAD_DOCUMENT: 'ERREUR_TELEVERSEMENT_DOCUMENT',
  ERROR_CREATE_POLICY: 'ERREUR_CREATION_POLICE',
  CUSTOMER_CANCELLATION: 'Annulation par le client',
  ADMIN_CANCELLATION: 'Annulation par l’administrateur',
  REPOSSESSION: 'Reprise du bien',
  WRITE_OFF: 'Radiation',
  OTHER: 'Autre',
  failed: 'Échec',
  documentNotUploaded: 'Document non téléchargé',
  notUploaded: 'Non téléchargé',
  documentUploadFailed: 'Échec du téléchargement du document',
  creatingPolicy: 'Création de la police',
  effectiveFrom: 'Effectif à partir du',
  by: 'Par',
  NEW: 'Neuf',
  USED: 'Utilisé',
  PRE_OWNED: 'D’occasion',
  overrideEmptyPrices: 'Remplacer les prix vides',
  optionA: 'Option A',
  optionB: 'Option B',
  optionC: 'Option C',
  optionD: 'Option D',
  increaseBy: 'Augmenter de',
  showing: 'Affichage',
  bulk: 'En masse',
  limitation: 'Limitation',
  limitations: 'Limitations',
  loadingPleaseWait: 'Chargement, veuillez patienter...',
  percentage: 'Pourcentage',
  replacement: 'Remplacement',
  savingPleaseWait: 'Enregistrement, veuillez patienter...',
  copyAdjustementsToThisDealer: 'Copy Copier chez ce concessionnaire',
  bulkAdjust: 'Ajustement en masse',
  discount: 'Remise',
  discounts: 'Remises',
  noDocumentsUploaded: 'Aucun document téléchargé',
  noDetailsSpecified: 'Aucun détail précisé',
  invalidJobItems: 'Articles de travail invalides',
  isForElectricVehicle: 'Est pour véhicule électrique',
  day: 'JOUR',
  longText: 'TEXTE_LONG',
  json: 'JSON',
  decimal: 'DÉCIMAL',
  formattedNumber: 'NOMBRE_FORMATÉ',
  formattedDecimal: 'DÉCIMAL_FORMATÉ',
  initialHereTabs: 'Onglets initial ici',
  dateTabs: 'Onglets date',
  fullNameTabs: 'Onglets nom complet',
  signHereTabs: 'Onglets signer ici',
  replaceKey: 'Remplacer la clé',
  withKey: 'Avec la clé',
  copyTo: 'Copier vers',
  thisColumn: 'Cette colonne',
  allPricingPlans: 'Tous les plans tarifaires',
  thisPricingPlan: 'Ce plan tarifaire',
  relatedDeductibleClasses: 'Franchises/Classes associées',
  warranty: 'Garantie',
  sugRetail: 'Prix de détail suggéré',
  max: 'Max',
  min: 'Min',
  allGroups: 'Tous les groupes',
  thisGroup: 'Ce groupe',
  increaseAll: 'Tout augmenter',
  changeContractCreatorWarning:
    'Cette action peut affecter les documents associés et d’autres données liées au contrat.',
  ofApps: 'Des applications',
  totalSum: 'Somme totale',
  coverageType: 'Type de couverture',
  effectiveOn: 'En vigueur le',
  created: 'Créé',
  refundConfigTemplate: 'Modèle de configuration de remboursement',
  refundConfigTemplates: 'Modèles de configuration de remboursement',
  internalName: 'Nom interne',
  isEnabled: 'Est activé',
  cancellationPeriodThresholdDays: 'Seuil de période d’annulation (jours)',
  isLienHolderApplicable: 'Le titulaire du privilège est-il applicable?',
  minimumRetainedPremium: 'Prime minimale retenue',
  requiresCurrentOdometerReading: 'Nécessite la lecture actuelle du compteur kilométrique',
  maximumKmApplies: 'Le kilométrage maximum s’applique',
  dealerProtectProfitAmount: 'Montant du profit de protection du concessionnaire',
  dealerProtectProfitExpirationDays: "Jours d'expiration de la protection des bénéfices du concessionnaire",
  isCancellationLetterRequired: "La lettre d'annulation est-elle requise?",
  isInvoiceRequired: 'La facture est-elle requise?',
  termStartDateSource: "Source de la date d'entrée en vigueur de début de terme",
  refundType: 'Type de remboursement',
  claimJobPaymentStatusTrigger: 'Déclencheur de l’état de paiement des réclamations',
  claimJobPaymentEmailTemplates: 'Modèles d’e-mails de paiement des réclamations',
  financeEmailTemplates: 'Modèles d’e-mails financiers',
  financeEmailTemplate: 'Modèle d’e-mail financier',
  remittance: 'Virement',
  claimsRemittance: 'Virement des réclamations',
  claimsRemittanceAdvice: 'Avis de virement des réclamations',
  claimsRemittanceAdviceDocument: 'Document d’avis de virement des réclamations',
  deduction: 'Déduction',
  remittanceEmailAddress: 'Adresse e-mail de remise',
  paymentEmailAddress: 'Adresse e-mail de paiement',
  invalidEmailFormatRequires: 'Format d’e-mail invalide, requis: exemple@exemple.com',
  FULL_PULLBACK: 'Rappel complet',
  UNTOUCHED: 'Intact',
  PRO_RATED: 'Au prorata',
  legacy: 'Héritage',
  dealerCostPst: 'Coût du concessionnaire PST',
  dealerCostGstHst: 'Coût du concessionnaire GST/HST',
  dealerRemittancePst: 'Remise du concessionnaire PST',
  dealerRemittanceGstHst: 'Remise du concessionnaire GST/HST',
  dealerProfitPst: 'Profit du concessionnaire PST',
  dealerProfitGstHst: 'Profit du concessionnaire GST/HST',
  dealerRemittance: 'Remise du concessionnaire',
  dealerProfitTax: 'Taxe sur le bénéfice du concessionnaire',
  refundDocuments: 'Documents de remboursement',
  productRefundDocuments: 'Documents de remboursement du produit',
  transferOwnershipDocuments: 'Documents de transfert de propriété',
  productTransferOwnershipDocuments: 'Documents de transfert de propriété du produit',
  refundDocument: 'Document de remboursement',
  productRefundDocument: 'Document de remboursement du produit',
  transferOwnershipDocument: 'Document de transfert de propriété',
  productTransferOwnershipDocument: 'Document de transfert de propriété du produit',
  ownershipLogs: 'Journaux de propriété',
  maxVehicleAgeYears: 'Âge maximal du véhicule (en années)',
  maxVehicleAge: 'Âge maximal du véhicule',
  paymentCreated: 'Paiement créé',
  vehicleAgeIsNotValid: "L'âge du véhicule n'est pas valide",
  transfer: 'Transfert',
  transfers: 'Transferts',
  transferred: 'Transféré',
  transferToClient: 'Transférer au client',
  transferToNewClient: 'Transférer à un nouveau client',
  clientHistory: 'Historique du client',
  contractClientHistory: 'Historique du client du contrat',
  important: 'Important',
  balanceDueIsPayableUponReceipt: 'Le solde dû est payable à réception',
  referringDealer: 'Concessionnaire référent',
  aggregateLimitOfLiability: 'Limite globale de responsabilité',
  removeAdminFee: 'Supprimer les frais administratifs',
  refundQuotes: 'Devis de remboursement',
  refundQuote: 'Devis de remboursement',
  contractCancellation: 'Résiliation de contrat',
  contractCancellations: 'Résiliations de contrat',
  contractRefund: 'Remboursement de contrat',
  contractRefunds: 'Remboursements de contrat',
  contractRefundPayment: 'Paiement de remboursement de contrat',
  contractRefundInvoice: 'Facture de remboursement de contrat',
  refundPayment: 'Paiement de remboursement',
  refundInvoice: 'Facture de remboursement',
  refundInvoices: 'Factures de remboursement',
  contractSummaryAmounts: 'Montants récapitulatifs du contrat',
  contractSummaryAmount: 'Montants récapitulatifs du contrat',
  component: 'Composant',
  dealerCostAmount: 'Montant du coût du concessionnaire',
  dealerCostTotal: 'Coût total du concessionnaire',
  dealerProfitAmount: 'Montant du profit du concessionnaire',
  dealerProfitTotal: 'Profit total du concessionnaire',
  dealerASCProfit: 'Responsabilité du profit ASC du concessionnaire',
  dealerASCProfitAmount: 'Montant de la responsabilité du profit ASC du concessionnaire',
  dealerASCProfitTotal: 'Total de la responsabilité du profit ASC du concessionnaire',
  retail: 'Vente au détail',
  retailAmount: 'Montant au détail',
  retailSalePriceTotal: 'Prix de vente au détail total',
  cancellationDeductions: 'Déductions de résiliation',
  totalCustomerRefund: 'Remboursement total au client',
  totalDeductions: 'Déductions totales',
  totalDeduction: 'Déductions totales',
  totalRefundAmount: 'Montant total du remboursement',
  loyaltyPremiumApplies: 'La prime de fidélité s’applique',
  claimDeductionsApply: 'Les déductions pour sinistres s’appliquent',
  newAppNumber: 'Nouveau numéro de demande',
  totalToBeRefunded: 'Total à rembourser',
  refundAmount: 'Montant du remboursement',
  valueRetained: 'Valeur conservée',
  valueAtSales: 'Valeur à la vente',
  void: 'Annulé',
  jobId: 'ID de la tâche',
  initiatedBy: 'Initié par',
  dateInitiated: 'Date d’initiation',
  contractExpiration: 'Expiration du contrat',
  loyaltyPremium: 'Prime de fidélité',
  hasClaims: 'A des sinistres',
  api: 'API',
  yes: 'Oui',
  no: 'Non',
  processRefund: 'Traiter le remboursement',
  prRefund: 'Remboursement PR',
  process: 'Traiter',
  PROCESSING: 'EN COURS DE TRAITEMENT',
  kmOrDateBased: '',
  nameOfTemplateInvoked: '',
  dateBased: '',
  km: 'KM',
  applicable: 'Applicable',
  distribution: 'Distribution',
  original: 'Original',
  originalAmount: 'Montant original',
  retained: 'Retenu',
  retainedAmount: 'Montant retenu',
  refunded: 'Remboursé',
  refundedAmount: 'Montant remboursé',
  termInDays: 'Durée en jours',
  usedTermInDays: 'Durée utilisée en jours',
  usedTermInDaysPercentage: 'Pourcentage de durée utilisée (jours)',
  consumed: 'Consommé',
  usedOdometerReading: 'Kilométrage utilisé',
  usedOdometerReadingPercentage: 'Pourcentage du kilométrage utilisé',
  dealerCostValueAtSale: 'Valeur du coût du concessionnaire à la vente',
  dealerCostTaxAtSale: 'Taxe sur le coût du concessionnaire à la vente',
  dealerProfitValueAtSale: 'Valeur du profit du concessionnaire à la vente',
  dealerProfitTaxAtSale: 'Taxe sur le profit du concessionnaire à la vente',
  totalRefundedDealerAmt: 'Montant total remboursé au concessionnaire',
  totalRetainedDealerAmt: 'Montant total retenu du concessionnaire',
  retainedDealerCostAmt: 'Coût retenu du concessionnaire',
  retainedDealerCostTaxAmt: 'Taxe sur le coût retenu du concessionnaire',
  retainedDealerCostTotalAmt: 'Coût total retenu du concessionnaire',
  refundedDealerCostAmt: 'Montant remboursé du coût du concessionnaire',
  refundedDealerCostTaxAmt: 'Montant de la taxe remboursée du coût du concessionnaire',
  refundedDealerCostTotalAmt: 'Montant total remboursé du coût du concessionnaire',
  refundedDealerCostAndASCDealerProfitResponsibilityTotalAmt:
    'Coût du concessionnaire remboursé + montant du profit protégé du concessionnaire',
  unprotectedDealerProfitAmt: 'Profit non protégé du concessionnaire',
  unprotectedDealerProfitTaxAmt: 'Taxe sur le profit non protégé du concessionnaire',
  unprotectedDealerProfitTotalAmt: 'Profit total non protégé du concessionnaire',
  protectedDealerProfitAmt: 'Profit protégé du concessionnaire',
  retainedDealerProfitAmt: 'Portion à la charge du concessionnaire retenue',
  dealerProfitSubtotalAmt: 'Sous-total du profit du concessionnaire',
  refundedDealerProfitAmt: 'Portion à la charge du concessionnaire remboursée',
  retainedASCDealerProfitAmt: 'Profit retenu du concessionnaire',
  refundedASCDealerProfitAmt: 'Profit remboursé du concessionnaire',
  retailSalePriceValueAtSale: 'Prix de vente au détail au moment de la vente',
  remainingTermInDays: 'Durée restante en jours',
  retainFactor: 'Facteur de rétention',
  endorsements: 'Avenants',
  endorsement: 'Avenant',
  initiatedByUser: 'Initié par l’utilisateur',
  templateName: 'Nom du modèle',
  replacementContractNumber: 'Numéro du contrat de remplacement',
  refundInformation: 'Informations sur le remboursement',
  sumOfClaimAmountsPaidOnContract: 'Somme des montants des réclamations payées pour le contrat',
  sumOfClaimPreTaxAmountsPaidOnContract: 'Somme des montants avant taxes des réclamations payées pour le contrat',
  sumOfClaimGstHstAmountsPaidOnContract: 'Somme des montants de TPS/TVH des réclamations payées pour le contrat',
  sumOfClaimPstAmountsPaidOnContract: 'Somme des montants de TVP des réclamations payées pour le contrat',
  termAndExpiryInformation: 'Informations sur la durée et l’expiration',
  refundProcessWarning:
    'La modification de la lecture de l’odomètre ou de la date d’annulation entraînera le recalcul de tous les montants de remboursement précédemment calculés !',
  startingOdometer: 'Odomètre initial',
  startingOdometerReading: 'Lecture initiale de l’odomètre',
  kmsUsed: 'Kilomètres utilisés',
  kmConsumed: 'Kilomètres consommés',
  kmRemaining: 'Kilomètres restants',
  daysConsumed: 'Jours consommés',
  daysRemaining: 'Jours restants',
  termConsumed: 'Durée consommée',
  termRemaining: 'Durée restante',
  contractPricing: 'Tarification du contrat',
  enhacementsPriceCAD: 'Prix des améliorations (CAD)',
  surchargesPriceCAD: 'Prix des suppléments (CAD)',
  paymentTaxes: 'Taxes sur le paiement',
  totalPriceAmountWPaymentTaxes: 'Montant total avec taxes de paiement',
  salePriceTaxes: 'Taxes sur le prix de vente',
  totalRetailPriceAmountWSalePriceTaxes: 'Montant total de vente au détail avec taxes',
  dealerProfitNonASC: 'Profit du concessionnaire (hors ASC)',
  dealerProfitTaxes: 'Taxes sur le profit du concessionnaire',
  totalDealerProfitWDealerProfitTax: 'Profit total du concessionnaire avec taxe',
  totalDealerProfitWDealerProfitTaxes: 'Profit total du concessionnaire avec taxes',
  payeeInformation: 'Informations sur le bénéficiaire',
  addPayee: 'Ajouter un bénéficiaire',
  requestor: 'Demandeur',
  primaryPayee: 'Bénéficiaire principal',
  cannotBeDeleted: 'Ne peut pas être supprimé',
  documentManagement: 'Gestion des documents',
  recalculating: 'Recalcul en cours',
  baseCost: 'Coût de base',
  remainingPercentOfKms: 'Pourcentage restant de KM',
  usedPercentOfKms: 'Pourcentage utilisé de KM',
  totalRetainedSubtotal: 'Sous-total total retenu',
  totalRefundedSubtotal: 'Sous-total total remboursé',
  retailSalePriceTaxValueAtSale: 'Montant de la taxe du prix de vente au détail à la vente',
  retainedDealerProfitTaxAmt: 'Montant de la taxe sur la portion à la charge du concessionnaire retenue',
  refundedDealerProfitTaxAmt: 'Montant de la taxe sur la portion à la charge du concessionnaire remboursée',
  retainedASCDealerProfitTaxAmt: 'Montant de la taxe sur le profit du concessionnaire retenu',
  refundedASCDealerProfitTaxAmt: 'Montant de la taxe sur le profit du concessionnaire remboursé',
  totalRetainedDealerTaxAmt: 'Montant total de la taxe sur le profit du concessionnaire retenu',
  totalRefundedDealerTaxAmt: 'Montant total de la taxe sur le profit du concessionnaire remboursé',
  claimJobItemTaxEditWarning: 'La modification manuelle de la taxe remplace le calcul automatique!',
  clickToEdit: 'Cliquez pour modifier',
  logos: 'Logos',
  requiredLogos: 'Logos requis',
  requiredLogo: 'Logo requis',
  requiredTranslations: 'Traductions requises',
  requiredTranslation: 'Traduction requise',
  kms: 'KM',
  profitRetention: 'Rétention du profit',
  termDaysConsumed: 'Jours de durée consommés',
  termDaysRemaining: 'Jours de durée restants',
  percentOfTermConsumed: 'Pourcentage de la durée consommée',
  percentOfTermRemaining: 'Pourcentage de la durée restante',
  currentOdometerReading: 'Lecture actuelle du compteur kilométrique',
  maxCoverageKMUsedInDP: 'KM de couverture maximale (utilisés dans DP)',
  termInKM: 'Durée en KM',
  kmsUsedConsumed: 'KM utilisés / consommés',
  kmsRemaining: 'KM restants',
  percentOfKMConsumed: 'Pourcentage de KM consommés',
  percentOfKMRemaining: 'Pourcentage de KM restants',
  dealerProfitAmt: 'Montant du profit du concessionnaire',
  dealerProtectedProfitExpirationDays: 'Jours d’expiration du profit protégé du concessionnaire',
  dealerProtectedProfitExpirationDay: 'Jour d’expiration du profit protégé du concessionnaire',
  refundFactor: 'Facteur de remboursement',
  refundFactorAfterMinimumRetained: 'Facteur de remboursement après minimum retenu',
  providerStatementEmailTemplates: 'Modèles d’e-mails de paiement fournisseur',
  providerStatementEmailTemplate: 'Modèle d’e-mail de paiement fournisseur',
  providerStatementBalanceEmailTemplates: 'Modèles d’e-mails de relevé fournisseur',
  providerStatementBalanceEmailTemplate: 'Modèle d’e-mail de relevé fournisseur',
  providerStatementBalance: 'Relevé fournisseur',
  providerStatement: 'Paiement fournisseur',
  addTranslation: 'Ajouter une traduction',
  deleteTranslation: 'Supprimer la traduction',
  actualRefund: 'Remboursement réel',
  refundQuoteAmount: 'Montant du devis de remboursement',
  prorateRemainingTimeOrKmAtRisk: 'Proratiser le temps/kilométrage restant à risque',
  maxFinanceToPurchasePriceRatio: 'Maximum du ratio financement/prix d’achat',
  maxFinancedAmountRation: 'Ratio maximal du montant financé',
  eq: 'Égal',
  gt: 'Supérieur à',
  gte: 'Supérieur ou égal à',
  lt: 'Inférieur à',
  lte: 'Inférieur ou égal à',
  in: 'Contient',
  RANGE: 'Plage',
  searchBy: 'Rechercher par',
  publicSearchContractTitle: 'Soumettre une nouvelle réclamation',
  publicSearchContractParagraph:
    'Recherchez le contrat en utilisant le NIV et le nom du client, ou le numéro de contrat. Une fois localisé, sélectionnez le contrat pour démarrer la réclamation.',
  claimSubmissionTitle: 'Détails de la demande de réclamation',
  claimSubmissionParagraph:
    'Indiquez qui soumet cette réclamation et fournissez les renseignements requis pour continuer',
  claimInfoTitle: 'Détails de la réclamation',
  claimInfoParagraph: 'Veuillez fournir les renseignements requis sur la réclamation',
  jobInfo: 'Bon de travail',
  jobInfoParagraph: 'Entrez les informations requises pour créer le bon de travail',
  supportingDocumentationParagraph: 'Ajoutez les documents ou les images nécessaires pour créer le bon de travail',
  jobItemsParagraph:
    'Veuillez remplir tous les éléments applicables afin d’obtenir les totaux soumis avec la réclamation. Pour les éléments qui ne s’appliquent pas, veuillez les laisser vides',
  publicClaimReview: 'Vérification',
  publicClaimReviewParagraph:
    'Examinez tous les détails de la réclamation avant de continuer. Veillez à ce que le contrat, les détails de la réclamation, les dates et les renseignements du client sont corrects',
  thankYou: 'Merci',
  publicClaimFinishSuccess:
    'Votre réclamation a été envoyée avec succès. Nous en vérifierons les détails et vous contacterons si nous avons besoin d’informations additionnelles',
  savingYourClaim: 'Enregistrement de votre réclamation',
  saveClaimPleaseWait: 'Veuillez patienter pendant que nous soumettons les renseignements relatifs à votre réclamation',
  addJob: 'Ajouter un bon de travail',
  entity: 'Entité',
  classCode: 'Code de classe',
  isVehicleInoperable: 'Le véhicule est-il hors d’état de marche',
  showOnlySelected: 'Afficher uniquement les éléments sélectionnés',
  dealerPaymentControls: 'Contrôles de paiement du concessionnaire',
  allocatedAmount: 'Montant alloué',
  fundingSource: 'Source de financement',
  responsibilityType: 'Responsabilité',
  paymentPurpose: 'Objet du paiement',
  accountingItemType: 'Élément comptable',
  addRow: 'Ajouter une ligne',
  none: 'Aucun',
  shared: 'Partagée',
  ap: 'CP',
  ar: 'CR',
  ascRefundPortion: 'Portion de remboursement ASC',
  fullCustomerRefund: 'Remboursement complet au client',
  dealerReimbursement: 'Remboursement au concessionnaire',
  dealerRespPortion: 'Portion de responsabilité du concessionnaire',
  lienholderRefund: 'Remboursement au créancier hypothécaire',
  adminFeeRefund: 'Remboursement des frais administratifs',
  removeCurrentPrimaryPayeeFirst: 'Veuillez d’abord retirer le bénéficiaire principal actuel',
  exactlyOnePrimaryPayeeRequired: 'Un seul bénéficiaire doit être désigné comme principal',
  addControl: 'Ajouter un contrôle',
  dealerCostControl: 'Contrôle du coût concessionnaire',
  dealerProfitControl: 'Contrôle du profit concessionnaire',
  dealerCostControls: 'Répartitions du remboursement de contrat ASC',
  dealerProfitControls: 'Répartitions du remboursement du profit concessionnaire',
  dealerProtectedProfitAmount: 'Montant du profit protégé du concessionnaire',
  dealerResponsiblePortion: 'Portion à la charge du concessionnaire',
  dealerResponsiblePortionAmount: 'Montant de la portion à la charge du concessionnaire',
  dealerResponsiblePortionTotal: 'Total de la portion à la charge du concessionnaire',
  dealerCostLessAllDeductions: 'Coût concessionnaire moins toutes les déductions',
  ascDealerProfitResponsibility: 'Profit du concessionnaire',
  ascDealerProfit: 'Profit ASC du concessionnaire',
  totalToBeRefundedToCustomer: 'Total à rembourser au client',
  dealerProfitProtectedHeldBackForRecovery: 'Profit concessionnaire, montant protégé retenu pour recouvrement',
  recoverableFromDealerNotPartOfCustomerRefund:
    'Dont recouvrable auprès du concessionnaire — ne fait pas partie du remboursement au client',
  retainedDealerCostBeforeDeductions: 'Coût concessionnaire conservé avant déductions',
  showDeductionBreakdown: 'Afficher le détail des déductions',
  hideDeductionBreakdown: 'Masquer le détail des déductions',
  dealerCostRefundTotal: 'Total du remboursement du coût concessionnaire',
  dealerProfitRefundTotal: 'Total du remboursement du profit concessionnaire',
  remaining: 'Restant',
  refundedDealerProfitTotalAmt: 'Portion à la charge du concessionnaire',
  atLeastOneAccountPayableRequired: 'Au moins un contrôle doit être marqué comme Compte fournisseur (AP)',
  dealerCostControlFullAmountRequired:
    'Un contrôle du coût concessionnaire est requis et le montant restant du coût concessionnaire remboursé doit être de 0 $ ou moins',
  noSearchResults: 'Aucun résultat trouvé. Veuillez vérifier vos critères de recherche et réessayer.',
  contractRefundInvoices: 'Factures de remboursement de contrat',
  dealerPaymentControl: 'Contrôle de paiement du concessionnaire',
  regenerateInvoiceDocument: 'Régénérer le document de facture',
  invoiceSuccessfullyGenerated: 'Document de facture généré avec succès',
  paymentRequestedAt: 'Paiement demandé le',
  contractRefundInvoiceStatusTrigger: 'Déclencheur de statut de facture de remboursement',
  CONTRACT_REFUND_INVOICE_CREATED: 'CONTRACT_REFUND_INVOICE_CREATED',
  sendToInvoiceCreator: 'Utilisateur ayant créé la facture',
  refundJobId: 'Numéro de dossier de remboursement',
  formatted: 'formaté',
  invoiceEmailWillHaveNoAttachment:
    "Cette facture n'a pas encore de document, le courriel sera donc envoyé sans pièce jointe. Régénérez d'abord le document de facture pour l'inclure.",
  carbonCopies: 'Copies conformes (Cc)',
  alsoPrintedOnInvoicePdf: 'Également imprimé comme ligne Cc sur le PDF de la facture.',
  signingCertificateOfCompletion: "Certificat d'achèvement de la signature",
  certificate: 'Certificat',
  importFromSignFlow: 'Importer depuis SignFlow',
  uploadManually: 'Télécharger manuellement',
  certificateNotAvailableInSignFlow: "Le certificat n'est pas disponible dans SignFlow. Téléchargez-le manuellement.",
  downloadFromSignFlow: 'Télécharger depuis SignFlow',
};
export default fr;
